<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- logo -->
    <div class="logo">
      <img v-if="bannerArr.length > 0" :src="$imgUrl+bannerArr[0].thumb" alt="" />
    </div>
    <div class="container">
      <div class="download_title">{{ fileDetail.name }}</div>
      <div class="download_list" v-if="fileArr.length > 0">
        <div
          class="download_item"
          v-for="(item, index) in fileArr"
          :key="index"
        >
          <div class="download_left_box">
            <img class="pdf_icon" src="../../assets/pdf.jpg" alt="" />
            <div class="pdf_box">
              <div class="pdf_title1">{{ item.name }}</div>
              <div class="pdf_title2">{{ item.create_time }}</div>
            </div>
          </div>
          <div class="download_btn" @click="downloadFile(item)">
            <img src="../../assets/download.jpg" alt="" />
            <span>{{ langSet == "cn" ? "立即下载" : "Download" }}</span>
          </div>
        </div>
      </div>
      <div class="nodata_box" v-else>
        <nodata></nodata>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import nodata from "../../components/nodata.vue";
import { getBanner, getFileList, getfileDetail } from "@/api/api";
export default {
  components: { top, bottom, nodata },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: "BCEIA-资料下载",
      meta: [
        {
          name: "description",
          content: "资料下载资料下载资料下载",
        },
      ],
    };
  },
  data() {
    return {
      langSet: "",
      bannerArr: [],
      fileArr: [],
      id: "",
      fileDetail: {},
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
    this.getFile(this.id);
    this.getfileDetail(this.id);
  },
  methods: {
    // zhang 获取资料下载banner
    getBannerList() {
      let data = {
        class: "资料下载",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取资料下载列表
    getFile(id) {
      let data = {
        page_no: 1,
        page_size: 98,
        cid: id,
      };
      getFileList(data)
        .then((res) => {
          if (res.code == 1) {
            this.fileArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getfileDetail(id) {
      let data = {
        id: id,
      };
      getfileDetail(data)
        .then((res) => {
          if (res.code == 1) {
            this.fileDetail = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    downloadFile(item) {
      window.location.href = item.url;
    },
  },
  watch: {
    $route: {
      handler(val, oldval) {
        console.log(val); //新路由信息
        // if(val.params.id,"id")
        this.getFile(val.params.id);
        this.getfileDetail(val.params.id);
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.nodata_box {
  margin: 100px 0 50px;
}
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.container {
  // width: 1280px;
  margin: 50px auto 80px;
  background: rgba(171, 181, 205, 0.1);
  padding: 50px 50px 30px;
  box-sizing: border-box;
  .download_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #2c2c2e;
    margin-bottom: 30px;
  }
  .download_list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .download_item {
      width: 580px;
      background: #ffffff;
      border-radius: 8px;
      padding: 30px 35px 30px 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      &:hover .pdf_title1 {
        color: #233889 !important;
      }
      .download_left_box {
        display: flex;
        .pdf_icon {
          width: 49px;
          height: 56px;
        }
        .pdf_box {
          margin-left: 10px;
          .pdf_title1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #2c2c2e;
            line-height: 22px;
            margin-bottom: 5px;
          }
          .pdf_title2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #757575;
            line-height: 20px;
          }
        }
      }
      .download_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 108px;
        height: 38px;
        background: #ffffff;
        border-radius: 21px;
        border: 1px solid #243889;
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
        }
        span {
          display: inline-block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #243889;
          margin-left: 5px;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .logo {
    height: 81px !important;
    margin-top: 0.88rem;
    img {
      height: 81px !important;
    }
  }
  .container {
    width: 90% !important;
    margin: 50px auto !important;
    padding: 0 !important;
    background: #ffffff !important;
    .download_item {
      width: 100% !important;
      padding: 16px 10px 21px 15px !important;
      background: rgba(171, 181, 205, 0.1) !important;
      margin-bottom: 15px !important;
    }
    .download_title {
      font-weight: 500 !important;
      font-size: 18px !important;
      color: #009ffc !important;
      margin-bottom: 20px !important;
    }
    .pdf_title1 {
      margin-bottom: 18px !important;
    }
  }
}
</style>